'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { ChevronDown } from 'lucide-react';

export function FAQSection() {
  const t = useTranslations('landing.pricing.faq');

  const faqs = [
    {
      category: t('pricingBilling'),
      questions: [
        { question: t('qPaymentMethods'), answer: t('aPaymentMethods') },
        { question: t('qFreeTrial'), answer: t('aFreeTrial') },
        { question: t('qCancel'), answer: t('aCancel') },
      ],
    },
    {
      category: t('productFeatures'),
      questions: [
        { question: t('qPracticeVsStructured'), answer: t('aPracticeVsStructured') },
        { question: t('qRecordings'), answer: t('aRecordings') },
        { question: t('qIntegrations'), answer: t('aIntegrations') },
      ],
    },
    {
      category: t('securityPrivacy'),
      questions: [
        { question: t('qDataSecure'), answer: t('aDataSecure') },
        { question: t('qWhoAccess'), answer: t('aWhoAccess') },
        { question: t('qExportData'), answer: t('aExportData') },
      ],
    },
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4 max-w-3xl">
        <h2 className="text-3xl font-serif text-white text-center mb-12">{t('title')}</h2>

        <div className="space-y-8">
          {faqs.map((category) => (
            <div key={category.category}>
              <h3 className="text-sm font-semibold text-primary uppercase tracking-wider mb-4">
                {category.category}
              </h3>
              <div className="space-y-2">
                {category.questions.map((faq) => (
                  <FAQItem key={faq.question} {...faq} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQItem({ question, answer }: { question: string; answer: string }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border border-white/10 rounded-lg overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-4 text-left hover:bg-white/[0.04] transition-colors"
      >
        <span className="font-medium text-white">{question}</span>
        <ChevronDown
          className={`w-5 h-5 text-white/40 transition-transform ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>
      {isOpen && <div className="px-4 pb-4 text-white/60">{answer}</div>}
    </div>
  );
}
